import React, { useState, useEffect } from "react";
import { Fade } from "react-awesome-reveal";
import "../styles/Carousel.scss";
import Whats from "./Whats";
import img1 from "../images/carousel/1.png";
import img2 from "../images/carousel/2.png";
import img3 from "../images/carousel/3.png";
import img4 from "../images/carousel/4.png";
import img5 from "../images/carousel/5.png";
import img6 from "../images/carousel/6.png";

const Carousel = () => {
  const [anos, setAnos] = useState(0);
  const [reparaciones, setReparaciones] = useState(0);
  const [clientes, setClientes] = useState(0);

  let anosMax = 10;
  let reparacionesMax = 1500;
  let clientesMax = 50;

  useEffect(() => {
    const intervalId1 = setInterval(() => {
      if (anos < anosMax) {
        setAnos(anos + 1);
      } else {
        clearInterval(intervalId1);
      }
    }, 10);

    return () => clearInterval(intervalId1);
  }, [anos]);

  useEffect(() => {
    const intervalId2 = setInterval(() => {
      if (reparaciones < reparacionesMax) {
        setReparaciones(reparaciones + 50);
      } else {
        clearInterval(intervalId2);
      }
    }, 5);

    return () => clearInterval(intervalId2);
  }, [reparaciones]);

  useEffect(() => {
    const intervalId3 = setInterval(() => {
      if (clientes < clientesMax) {
        setClientes(clientes + 5);
      } else {
        clearInterval(intervalId3);
      }
    }, 10);

    return () => clearInterval(intervalId3);
  }, [clientes]);

  return (
    <div className="mb-5 carouselContainer" id="inicio">
      <div className="carouselText">
        <Fade>
          <h1 className="title1 mt-3">
            <b>SySdL Servicios de Limpieza Industrial y Comercial Monterrey</b>
          </h1>
        </Fade>
        <h2 className="mb-3 title2">
          "Ofrecemos Soluciones de Limpieza Personalizadas para Cada Una de Tus Necesidades"
        </h2>
        <span className="firstText">
        En SySdL (Servicios y Soluciones de Limpieza) somos una empresa mexicana dedicada a ofrecer soluciones de limpieza eficaces y personalizadas para empresas, oficinas y hogares. Con un equipo altamente capacitado y utilizando equipos de última tecnología, nos aseguramos de proporcionar un servicio de alta calidad que supere las expectativas de nuestros clientes.<br/><br/>
        Nos especializamos en limpieza industrial y comercial, cubriendo una amplia gama de servicios como el lavado y desinfección de sanitarios, limpieza de vidrios de altura, desengrasado de cocinas industriales, limpieza post remodelación, y más. Además, estamos comprometidos con el cuidado del medio ambiente, utilizando productos ecológicos siempre que sea posible.
          <br />
        </span>
        <Fade>
          <div className="container containerDatosMain mt-4 mb-3">
            <div className="containerDatos">
              <span className="text-center contadorNum fw-bold" id="anosExp">
                {"+" + anos}
              </span>
              <br />
              <span className="contadorNumText fw-bold">
                Años de experiencia
              </span>
            </div>
            <div className="containerDatos">
              <span className="contadorNum fw-bold" id="reparaciones">
                {"+" + reparaciones}
              </span>
              <br />
              <span className="contadorNumText fw-bold">
                Servicios realizados
              </span>
            </div>
            <div className="containerDatos">
              <span className="contadorNum fw-bold" id="clientes">
                {"+" + clientes}
              </span>
              <br />
              <span className="contadorNumText fw-bold">
                Clientes satisfechos
              </span>
            </div>
          </div>
        </Fade>

        <Fade cascade="true" direction="left">
          <div className="mt-4 container containerBtn1">
            <Whats
              classStyle="col-sm-6 mb-2 fw-bold btn btnCarousel"
              phoneNumber="5218131053905"
              message="Hola, quiero más información acerca de sus servicios"
              text="CONTÁCTANOS"
            />
          </div>
        </Fade>
      </div>

      <div className="carouselImages">
        <div
          id="carouselExampleAutoplaying"
          className="carousel slide"
          data-bs-ride="carousel"
        >
          <div className="carousel-inner imgBox">
            <div className="carousel-item active">
              <center>
                <img
                  src={img1}
                  className="d-block w-100 "
                  alt="Lavado de vidrios de altura"
                />
              </center>
            </div>
            <div className="carousel-item">
              <center>
                <img
                  src={img2}
                  className="d-block w-100 "
                  alt="Lavado y desinfección de sanitarios"
                />
              </center>
            </div>
            <div className="carousel-item">
              <center>
                <img
                  src={img3}
                  className="d-block w-100 "
                  alt="Desengrasado de cocinas industriales"
                />
              </center>
            </div>
            <div className="carousel-item">
              <center>
                <img
                  src={img4}
                  className="d-block w-100 "
                  alt="Lavado de techos, ductos y paredes"
                />
              </center>
            </div>
            <div className="carousel-item">
              <center>
                <img
                  src={img5}
                  className="d-block w-100 "
                  alt="Lavado y desengrasado de estacionamientos"
                />
              </center>
            </div>
            <div className="carousel-item">
              <center>
                <img
                  src={img6}
                  className="d-block w-100 "
                  alt="Lavado y encerado de pisos"
                />
              </center>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Carousel;
